module.exports = __webpack_public_path__ + "img/dog.cf39ade9.svg";